const doc = [({"en":({"js":({"admin":({"bank_accounts":({"create_bank_account":"Create account"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;